import React from "react";
import Breadcrumbs from "../../common/Breadcrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, IconButton, Card } from "@mui/material";
import DownloadIcon from "../../assets/downlaod.svg";
import CloseIcon from "../../assets/cross.svg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ShipmentType } from "../../types/Shipment";
import DataTable from "../../common/DataTable";

//memoize clumns
const columns = [
  { label: "Customer", field: "customer" },
  { label: "Location", field: "location" },
  {
    label: "Order Details",
    field: "orderDetails",
    renderCell: (row: ShipmentType) => (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="body2" style={{ fontSize: "10.66px" }}>
          {row.orderDetails.orderId}
        </Typography>
        <Typography
          variant="body2"
          style={{ fontSize: "11.63px", fontWeight: 600 }}
        >
          {row.orderDetails.price}
        </Typography>
      </Box>
    ),
  },
  {
    label: "Truck No",
    field: "truckNo",
  },
  {
    label: "Driver Name",
    field: "driverName",
  },
  {
    label: "Phone Number",
    field: "phone",
  },
];

const rowStyle = (index: number) => {
  return {
    backgroundColor: index % 2 === 0 ? "#e0e0e0" : "#f9fbfd",
  };
};

const ShipmentSummary: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { selectedOrders } = state || { selectedOrders: [] };

  const orgId = localStorage.getItem("orgId");

  const handleDownload = async () => {
    const element = document.getElementById("shipment-summary");

    if (element) {
      const clonedElement = element.cloneNode(true) as HTMLElement;

      const actionButtons = clonedElement.querySelectorAll(".action-button");
      actionButtons.forEach((button) => {
        (button as HTMLElement).style.display = "none";
      });

      const tempContainer = document.createElement("div");
      tempContainer.style.position = "absolute";
      tempContainer.style.top = "-9999px";
      tempContainer.style.left = "-9999px";
      tempContainer.appendChild(clonedElement);
      document.body.appendChild(tempContainer);
      const canvas = await html2canvas(clonedElement, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF();
      pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
      pdf.save("ShipmentSummary.pdf");

      document.body.removeChild(tempContainer);
    }
  };

  const handleClose = () => {
    navigate(`/${orgId}/seller/shipment`);
  };

  return (
    <>
      <Breadcrumbs
        paths={["Shipment", "Shipment Summary"]}
        links={["/seller/shipment", "/seller/shipment-summary"]}
      />

      <Card
        id="shipment-summary"
        sx={{
          borderTopRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#eaeaea",
            padding: 0.5,
            borderTopRadius: 1,
          }}
        >
          <Typography
            sx={{
              marginLeft: 3,
            }}
            variant="h6"
          >
            Shipment Summary
          </Typography>
          <Box>
            <IconButton
              className="action-button"
              color="primary"
              onClick={handleDownload}
            >
              <img
                src={DownloadIcon}
                alt="Download"
                style={{ width: 40, height: 40 }}
              />
            </IconButton>
            <IconButton
              className="action-button"
              color="secondary"
              onClick={handleClose}
            >
              <img
                src={CloseIcon}
                alt="Close"
                style={{ width: 40, height: 40 }}
                data-testid="close-button"
              />
            </IconButton>
          </Box>
        </Box>
        <Box padding={2}>
          <DataTable
            columns={columns.map((col) => ({
              ...col,
              labelStyle: { fontSize: "14px", color: "#151C28" },
              cellStyle:
                col.field === "customer"
                  ? { fontWeight: 600, fontSize: "13px" }
                  : { fontSize: "11.63px" },
            }))}
            data={selectedOrders}
            rowStyle={rowStyle}
          />
        </Box>
      </Card>
    </>
  );
};

export default ShipmentSummary;
